import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "@store";
import { ADD_PROJECT_PARAM } from "app/routes";
import { projectSelector, setAddProjectDialogOpenedState } from "slices/project/projectSlice";

export const useAddProjectOpened = () => {
  const dispatch = useAppDispatch();
  const { isAddProjectDialogOpened } = useSelector(projectSelector);
  return useEffect(() => {
    const addProjectOpened = new URLSearchParams(window.location.search).get(ADD_PROJECT_PARAM) || "";
    if (addProjectOpened.toLowerCase() === "true" && !isAddProjectDialogOpened) {
      dispatch(setAddProjectDialogOpenedState(true));
    }
  }, []); //run effect only once
};
